import { KPI_VALUE_CLASSIC } from '@/utils/hooks/format/useFormatKpiValue';

import { colors } from '@/lib/analytics/colors';
import type { KpiType } from '@/lib/analytics/kpis/kpi.type';
import { ORIENTATION_VERTICAL } from '@/lib/gridElements/orientation';
import { SIZE_33 } from '@/lib/gridElements/size';

import { KPIDefault } from '@/components/base/Kpi/KpiDefault';
import { DefaultLoader } from '@/components/base/Kpi/KpiLoader';

export const totalReplyCountConfig: KpiType<typeof DefaultLoader, typeof KPIDefault> = {
    name: 'kpi.twitter.total_reply_count',
    id: 'replies',
    orientation: ORIENTATION_VERTICAL,
    icon: {
        name: 'reply',
        style: colors.blue
    },
    growth_tooltip: {
        up: 'analytics:kpi.growth_tooltip.up',
        down: 'analytics:kpi.growth_tooltip.down',
        still: 'analytics:kpi.growth_tooltip.still'
    },
    data_format: KPI_VALUE_CLASSIC,
    tooltip: 'kpi.twitter.tooltip_total_reply_count',
    size: SIZE_33,
    type: 'kpi',
    mergedData: true,
    splits: {
        organic: 'replies_organic',
        paid: 'replies_paid'
    },
    element: KPIDefault,
    loader: DefaultLoader
};
